import React from "react";
// import LeftMenu from "../../Components/LeftMenu";
import queryString from "query-string";
import Search from "../../Components/Assistant/Search";

const AssistantSearch = ({ match, location }) => {
    
    const query = queryString.parse(location.search);
    
    return (
        <React.Fragment>
        {/* <LeftMenu /> */}
        <Search
            pageNumber={query.pageNumber}
            search={query.search ? query.search : ""}
        />
        </React.Fragment>
    );
};

export default AssistantSearch;
